// removed by extract-text-webpack-plugin
module.exports = {"chartCard":"app-1ZNyecMa","chartTop":"app-1mPWL4BE","chartTopMargin":"app-Lh1nS5__","chartTopHasMargin":"app-fdZCnqRM","metaWrap":"app-2b4rpbaN","avatar":"app-NjnxYsLa","meta":"app-1-nGnhld","action":"app-3-LSvzyn","total":"app-BFz3xMIl","content":"app-yAp8jPB7","contentFixed":"app-22mcAD-k","footer":"app-1Uc0LfIo","footerMargin":"app-1Rd_xNHw","title":"app-1SXtH6Q7","spin":"app-2OYA1Hkw"};


//////////////////
// WEBPACK FOOTER
// ./src/wbap-components/charts/ChartCard/index.less
// module id = 595
// module chunks = 0